"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_transition_group_1 = require("react-transition-group");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
const useHistoryOptions_1 = require("../../hooks/useHistoryOptions");
const animation_1 = require("../../utils/animation");
function ToolsHeader({ opened, clearTitle, doneTitle, secondary = false, onClear, onDone, children, isClearActive: isClearActiveProp, }) {
    const theme = (0, styled_components_1.useTheme)();
    const containerRef = (0, react_1.useRef)(null);
    const { isClearActive } = (0, useHistoryOptions_1.useHistoryOptions)();
    const onMouseDown = (e) => {
        e.stopPropagation();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(containerRef, events.down, onMouseDown);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: opened, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ToolsHeader_CSSTransition', children: (0, jsx_runtime_1.jsx)(Container, { ref: containerRef, "data-e2e": 'ToolsHeader_Container', children: (0, jsx_runtime_1.jsxs)(StyledHeader, { "$backgroundColor": secondary ? theme.blue : theme.green, className: "tools-header", "data-e2e": 'ToolsHeader_StyledHeader', children: [(!!isClearActive || isClearActiveProp) && clearTitle && ((0, jsx_runtime_1.jsx)(ui_1.Header.Left, { children: (0, jsx_runtime_1.jsx)(ClearButton, { onClick: onClear, "data-e2e": 'ToolsHeader_ClearButton', children: clearTitle }) })), (0, jsx_runtime_1.jsx)(Content, { "data-e2e": 'ToolsHeader_Content', children: children }), (0, jsx_runtime_1.jsx)(ui_1.Header.Right, { children: (0, jsx_runtime_1.jsx)(DoneButton, { onClick: onDone, "data-e2e": 'ToolsHeader_DoneButton', children: doneTitle ? doneTitle : (0, i18n_1.Localized)(i18n_1.Strings.tools.header.done) }) })] }) }) }));
}
exports.default = ToolsHeader;
const Container = styled_components_1.default.div `
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  height: ${({ theme }) => theme.headerHeight}px;
  min-height: ${({ theme }) => theme.headerHeight}px;
  ${(0, animation_1.SlideUp)('100%')}
`;
const StyledHeader = (0, styled_components_1.default)(ui_1.Header) `
  height: ${({ theme }) => theme.headerHeight}px;
  min-height: ${({ theme }) => theme.headerHeight}px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;
const Content = styled_components_1.default.div `
  display: flex;
  align-items: center;

  color: ${props => props.theme.white};

  font-size: 18px;
`;
const DoneButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  height: 100%;

  margin: 0;
  padding: 0 15px 0 0;

  color: ${props => props.theme.white};

  font-size: 16px;
`;
const ClearButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  height: 100%;

  margin: 0;
  padding: 0 0 0 15px;

  color: ${props => props.theme.white};

  font-size: 16px;
`;
